import serverInterface from 'server-interface';

import {
  applyTraits
} from 'utilities/javascript';

import DataManagerTraits from '../traits';

class SentMessageBookmarks {

  constructor(application) {

    this.initialized = false;
    this.loaded = false;
    this.collection = [];

    this.application = application;

  }

  registerEventHandlers() {}

  async loadAll() {

    if (this.loaded === true) {
      return;
    }

    this.collection = await serverInterface.startup.sentMessageBookmarks.getSentMessageBookmarks({});

    this.loaded = true;

  }

  async create(payload) {

    const bookmark = await serverInterface.startup.sentMessageBookmarks.createSentMessageBookmark(payload);

    this.tryAdd(bookmark);

    return bookmark;

  }

  async delete(itemId) {

    await serverInterface.startup.sentMessageBookmarks.deleteSentMessageBookmark(itemId);

    this.tryRemove(itemId);

  }

  async initialize(bootstrapData) {

    this.registerEventHandlers();

    this.initialized = true;

  }

}

export default applyTraits(SentMessageBookmarks, [DataManagerTraits]);